import { render, staticRenderFns } from "./CompanyFormsEscalated.vue?vue&type=template&id=9457c944&scoped=true&"
import script from "./CompanyFormsEscalated.vue?vue&type=script&lang=js&"
export * from "./CompanyFormsEscalated.vue?vue&type=script&lang=js&"
import style0 from "./CompanyFormsEscalated.vue?vue&type=style&index=0&id=9457c944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9457c944",
  null
  
)

export default component.exports